export default "__VITE_ASSET__Cd1MNgE6__"